function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { translate } from '../../utils/helpers';
import FormErrors from '../FormErrors';
import PropTypes from 'prop-types';
import Form from '../../utils/Form';
import { LANG, API_URL, DEFAULT_LANG, SITE_NAME } from '../../utils/constant';

var OrderCataloguePage = /*#__PURE__*/function (_Component) {
  _inherits(OrderCataloguePage, _Component);

  var _super = _createSuper(OrderCataloguePage);

  function OrderCataloguePage(props) {
    var _this;

    _classCallCheck(this, OrderCataloguePage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "validateForm", function () {
      _this.setState({
        formValid: _this.state.fields.filter(function (field) {
          return field.valid === false;
        }).length === 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setFields", function (fields) {
      var shouldValidateForm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.setState({
        fields: fields
      }, function () {
        if (shouldValidateForm) {
          _this.validateForm();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function () {
      if (_this.orderCatalogue.current.isFormValid()) {
        _this.createPost();

        _this.props.history.push('/sent');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "boolToString", function (val) {
      if (val) return '1';else return '0';
    });

    _defineProperty(_assertThisInitialized(_this), "createPost", function () {
      var info = {
        number: _this.state.fields[0].value,
        firstName: _this.state.fields[1].value,
        lastName: _this.state.fields[2].value,
        email: _this.state.fields[3].value,
        phone: _this.state.fields[4].value,
        fax: _this.state.fields[5].value,
        company: _this.state.fields[6].value,
        position: _this.state.fields[7].value,
        address: _this.state.fields[8].value,
        postalCode: _this.state.fields[9].value,
        city: _this.state.fields[10].value,
        province: _this.state.fields[11].value,
        country: _this.state.fields[12].value,
        secteur: _this.state.fields[13].value,
        newsletter: _this.boolToString(_this.state.fields[14].value),
        sendTo: _this.getOrderCatalogueEmail(),
        defaultLang: DEFAULT_LANG,
        lang: LANG,
        websiteEmail: _this.getWebsiteEmail()
      };
      var url = API_URL + '/ask_catalog';
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(info)
      }).then(function (res) {
        if (res.status === 204) return '';
        return res.json();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getOrderCatalogueEmail", function () {
      return document.querySelector('#shop-page').getAttribute('order-catalogue');
    });

    _defineProperty(_assertThisInitialized(_this), "getWebsiteEmail", function () {
      var websiteEmail = document.querySelector('#shop-page').getAttribute('order-catalogue');
      return websiteEmail !== '' ? 'website@' + websiteEmail.split('@')[1] : 'siteweb@sani-depot.ca';
    });

    _this.receiveInfo = /*#__PURE__*/React.createRef();
    _this.orderCatalogue = /*#__PURE__*/React.createRef();
    _this.state = {
      fields: [{
        name: 'number',
        error: '',
        needValidation: false,
        valid: true,
        placeholder: translate('Catalog', 'Catalogue'),
        type: 'number',
        value: 1
      }, {
        name: 'firstName',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('First name', 'Prénom'),
        type: 'text',
        value: ''
      }, {
        name: 'lastName',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Lastname', 'Nom'),
        type: 'text',
        value: ''
      }, {
        name: 'email',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Email', 'Courriel'),
        type: 'email',
        value: ''
      }, {
        name: 'phone',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Phone', 'Téléphone'),
        type: 'text',
        value: ''
      }, {
        name: 'fax',
        error: '',
        needValidation: false,
        valid: true,
        placeholder: translate('Fax', 'Fax'),
        type: 'text',
        value: ''
      }, {
        name: 'company',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Company', 'Entreprise'),
        type: 'text',
        value: ''
      }, {
        name: 'position',
        error: '',
        needValidation: false,
        valid: true,
        placeholder: translate('Position', 'Position'),
        type: 'text',
        value: ''
      }, {
        name: 'address',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Address', 'Adresse'),
        type: 'text',
        value: ''
      }, {
        name: 'postalCode',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Postal Code', 'Code postal'),
        type: 'text',
        value: ''
      }, {
        name: 'city',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('City', 'Ville'),
        type: 'text',
        value: ''
      }, {
        name: 'province',
        error: '',
        needValidation: true,
        valid: true,
        placeholder: translate('Province', 'Province'),
        type: 'select',
        value: translate('Alberta', 'Alberta')
      }, {
        name: 'country',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Country', 'Pays'),
        type: 'text',
        value: ''
      }, {
        name: 'secteur',
        error: '',
        needValidation: false,
        valid: true,
        placeholder: translate('Field of activity', "Secteur d'activité"),
        type: 'text',
        value: ''
      }, {
        name: 'newsletter',
        error: '',
        needValidation: false,
        valid: true,
        placeholder: translate("Yes, I would like to receive informations regarding ".concat(SITE_NAME), "Oui je d\xE9sire recevoir des informations et nouveaut\xE9s relatives \xE0 ".concat(SITE_NAME)),
        type: 'checkbox',
        value: false
      }],
      provinces: [translate('Alberta', 'Alberta'), translate('British-Columbia', 'Colombie-Britannique'), translate('Prince Edward Island', 'Ile du Prince Édouard'), translate('Manitoba', 'Manitoba'), translate('New Brunswick', 'Nouveau Brunswick'), translate('Nova Scotia', 'Nouvelle Écosse'), translate('Ontario', 'Ontario'), translate('Quebec', 'Québec'), translate('Saskatchewan', 'Saskatchewan'), translate('Newfoundland and Labrador', 'Terre Neuve et Labrador'), translate('Northwest Territories', 'Territoires du Nord-Ouest'), translate('Nunavut', 'Nunavut'), translate('Yukon', 'Yukon')],
      formValid: false,
      receiveInfo: false
    };
    return _this;
  }

  _createClass(OrderCataloguePage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "order-catalogue-page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container "
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "certifications-page-title mobile-center main-bg-after"
      }, translate('Order a catalogue', 'Commandez un catalogue')), /*#__PURE__*/React.createElement("p", {
        className: "col-lg-6 col-md-12"
      }, translate('To receive your full catalogue, please fill the following this form below', 'Demandez gratuitement votre catalogue complet en remplissant le formulaire suivant')))), /*#__PURE__*/React.createElement("div", {
        className: "row catalogue second-bg"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-catalogue left col-lg-12 col-md-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "number-catalogue"
      }, /*#__PURE__*/React.createElement("span", null, translate('NUMBER OF CATALOGUE', 'NOMBRE DE CATALOGUE'))), /*#__PURE__*/React.createElement(Form, {
        fields: this.state.fields,
        provinces: this.state.provinces,
        ref: this.orderCatalogue,
        setParentState: function setParentState(fields, shouldValidateForm) {
          return _this2.setFields(fields, shouldValidateForm);
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "validation"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-dark btn-catalogue submit",
        onClick: this.submit
      }, translate('SUBMIT', 'ENVOYER'))), /*#__PURE__*/React.createElement(FormErrors, {
        fields: this.state.fields.filter(function (field) {
          return field.error !== '';
        })
      }))))));
    }
  }]);

  return OrderCataloguePage;
}(Component);

OrderCataloguePage.propTypes = {
  history: PropTypes.object
};
export default OrderCataloguePage;